import { render, staticRenderFns } from "./docrzbb.vue?vue&type=template&id=2e8d2f6e&scoped=true&"
import script from "./docrzbb.vue?vue&type=script&lang=js&"
export * from "./docrzbb.vue?vue&type=script&lang=js&"
import style0 from "./docrzbb.vue?vue&type=style&index=0&id=2e8d2f6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d2f6e",
  null
  
)

export default component.exports